import React from 'react';
import LoginForm from './LoginScreen_Components/LoginForm'

const LoginScreen = () => {
    return (
        <div className="w-full p-4 bg-red-50 pt-10 min-h-screen">
         
         <h2 className="w-full text-center text-lg my-10 xl:text-3xl">Welcome to Admin Restro</h2>

        <LoginForm/>



        </div>
    );
}

export default LoginScreen;
